<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-07-19 10:18:56
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-28 15:48:01
-->
<template>
	<Panel :contentPaddingTop="12" class="record">
		<platformTab @change="handleClick" :showAll="false" :platformId="platformId"></platformTab>
		<div class="multi-table" v-show="showPlatformContent">
			<multi-table :columns="columns" @gePartnerList="gePartnerList" :list="list" :total="total"></multi-table>
		</div>
	</Panel>
</template>
<script>
import { columns } from './columns'; //获取文本数据
import { operaterList } from '@/api/talentCRM';
import { platformMixin } from '@rd/rd-ui';

export default {
	name: 'record',
	components: {},
	mixins: [platformMixin],
	data() {
		return {
			list: [],
			platformId: 1,
			columns,
			total: '0',
			params: {
				page_index: 1,
				page_size: 10,
			},
			timer: null,
		};
	},
	mounted() {
		this.getExportList();
		this.getInterval();
	},
	methods: {
		getInterval() {
			this.timer && clearInterval(this.timer);
			this.timer = setInterval(() => this.getExportList(), 5000);
		},
		handleClick(val) {
			this.platformId = val;
			if (!this.showPlatformContent) return;
			this.getExportList(); //获取导出达人数据的列表
			this.getInterval();
		},
		async getExportList() {
			const {
				code,
				data: { list = [], page = {} },
			} = await operaterList({ ...this.params, platform_id: this.platformId });
			if (code === 0) {
				if (list.length === 0) {
					clearInterval(this.timer);
				}
				this.total = `${page.item_total}`;
				this.list = [...list];
			}
		},
		gePartnerList({ page_index, page_size }) {
			this.params.page_index = page_index;
			this.params.page_size = page_size;
			this.getExportList();
		},
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
};
</script>
